import React from 'react';
import './DishCard.css';

function DishCard({ dish, isAdmin, onEdit }) {
  return (
    <div className="dish-card">
      <div className="dish-card-inner">
        <div className="dish-image-container">
          <img 
            src={dish.image} 
            alt={dish.name}
            className="dish-image"
            loading="lazy"
            decoding="async"
          />
          {isAdmin && (
            <div className="admin-controls">
              <button 
                className="edit-btn" 
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(dish);
                }}
              >
                Edit
              </button>
            </div>
          )}
        </div>
        <div className="dish-content">
          <h3 className="dish-name">{dish.name}</h3>
          <div className="dish-ingredients">
            <span className="ingredients-label">Description:</span>
            <p className="ingredients-text">{dish.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DishCard;

